import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
// import MobFeed from './bplus-lib/MobFeed';
import MainPatient from "./patient-lib/MainPatient";
import {
  StyledEngineProvider,
  ThemeProvider,
  createTheme,
} from "@mui/material/styles";

// import MobClinic from './bplus-lib/MobClinic';
import WebClinic from "./bplus-lib/WebClinic";
import Manage from "./bplus-lib/Manage";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
// import MobAppointment from "./bplus-lib/MobAppointment";
import MobCoupon from "./bplus-lib/MobCoupon";
import MobKYC from "./bplus-lib/MobKYC";
import MobPHR from "./bplus-lib/MobPHR";
import MobLAB from "./bplus-lib/MobLAB";
// import MobInsurance from "./bplus-lib/MobInsurance";
import Admin from "./bplus-lib/Admin";
import Analytics from "./bplus-lib/Analytics";
import MobFeedSkeleton from "./bplus-lib/feed/MobFeedSkeleton";
import MobMedication from "./bplus-lib/MobMedication";
import MobSmartRegister from "./bplus-lib/MobSmartRegister";
import MobSmartAppointment from "./bplus-lib/MobSmartAppointment";
// import MobPayment from "./bplus-lib/MobPayment";
import MobHistory from "./bplus-lib/MobHistory";
import MobFeedSimulator from "./bplus-lib/MobFeedSimulator";
import MobAppointmentSimulator from "./bplus-lib/MobAppointmentSimulator";
import TeleDesktop from "./bplus-lib/TeleDesktop";

import { IntlProvider } from "react-intl";
import thMessage from "react-lib/localization/bplusClinic/th.json";
import { localizationTH } from "react-lib/localization/localization";
import CONFIG from "config/config";

import "react-table-6/react-table.css";
import "react-lib/css/ReactTable.css";
import "react-lib/css/CardLayout.css";

const thMsg = { ...localizationTH, ...thMessage };

const params = new URLSearchParams(window.location.search);
const app = params.get("app");
console.log("app: ", app);

let isMobile;
if (typeof globalThis !== "undefined") {
  isMobile =
    !!globalThis.mobile?.getAppointmentObject ||
    !!globalThis.iosNative ||
    !!globalThis.MobNative;
} else {
  isMobile =
    !!window.mobile?.getAppointmentObject ||
    !!window.iosNative ||
    !!window.MobNative;
}
console.log("isMobile: ", isMobile);

// เฉพาะ desktop เท่านั้น ที่ redirect
if (!app && CONFIG.NO_PATH_REDIRECT && !isMobile) {
  window.location.replace("/?app=TeleDesktop");
}

const patientId = params.get("patientId");

console.log(" Index.tsx init !!!", patientId);

declare global {
  var mobile: any;
  var setState: any;
  var webkit: any;
}

const MobAppointment = React.lazy(() => import("bplus-lib/MobAppointment"));
const MobFeed = React.lazy(() => import("bplus-lib/MobFeed"));
const MobClinic = React.lazy(() => import("bplus-lib/MobClinic"));
const MobSelectHospital = React.lazy(
  () => import("bplus-lib/MobSelectHospital")
);
const MobConsent = React.lazy(() => import("bplus-lib/MobConsent"));
const MobPayment = React.lazy(() => import("bplus-lib/MobPayment"));
const MobInsurance = React.lazy(() => import("bplus-lib/MobInsurance"));
const MobRadiology = React.lazy(() => import("bplus-lib/MobRadiology"));
const MobSurvey = React.lazy(() => import("bplus-lib/MobSurvey"));
const theme = createTheme();

// const MobMakeAppointmentUnsign = React.lazy(()=> import('bplus-lib/MobMakeAppointmentUnsign'))

ReactDOM.render(
  process.env.REACT_APP_BUILD_TARGET === "mobfeed" ? (
    <BrowserRouter>
      {" "}
      <Suspense fallback={<div>Loading...</div>}>
        {" "}
        <StyledEngineProvider injectFirst>
          {" "}
          <MobFeed />{" "}
        </StyledEngineProvider>
      </Suspense>
    </BrowserRouter>
  ) : // Build only MobClinic
  process.env.REACT_APP_BUILD_TARGET === "mobclinic" ? (
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>
        {" "}
        <StyledEngineProvider injectFirst>
          <MobClinic />
        </StyledEngineProvider>{" "}
      </Suspense>{" "}
    </BrowserRouter>
  ) : // Build only Manage
  process.env.REACT_APP_BUILD_TARGET === "bplus-manage" ? (
    <React.StrictMode>
      <BrowserRouter>
        <StyledEngineProvider injectFirst>
          {" "}
          <Manage patientId={patientId} />
        </StyledEngineProvider>
      </BrowserRouter>
    </React.StrictMode>
  ) : // Build only Admin
  process.env.REACT_APP_BUILD_TARGET === "bplus-admin" ? (
    <React.StrictMode>
      <BrowserRouter>
        <StyledEngineProvider injectFirst>
          <Admin />
        </StyledEngineProvider>
      </BrowserRouter>
    </React.StrictMode>
  ) : // Build only Analytics
  process.env.REACT_APP_BUILD_TARGET === "bplus-analytics" ? (
    <React.StrictMode>
      <BrowserRouter>
        <IntlProvider locale="th-TH" messages={thMsg}>
          <StyledEngineProvider injectFirst>
            <Analytics />{" "}
          </StyledEngineProvider>{" "}
        </IntlProvider>
      </BrowserRouter>
    </React.StrictMode>
  ) : (
    // Build all
    <React.StrictMode>
      {app === "MobFeed" ? (
        <BrowserRouter>
          <Suspense fallback={<MobFeedSkeleton />}>
            <StyledEngineProvider injectFirst>
              <MobFeed />
            </StyledEngineProvider>
          </Suspense>
        </BrowserRouter>
      ) : app === "MobFeedSimulator" ? (
        <BrowserRouter>
          <Suspense fallback={<MobFeedSkeleton />}>
            {" "}
            <StyledEngineProvider injectFirst>
              <MobFeedSimulator />
            </StyledEngineProvider>{" "}
          </Suspense>{" "}
        </BrowserRouter>
      ) : app === "MobAppointment" ? (
        <BrowserRouter>
          <Suspense fallback={<div>Loading...</div>}>
            <StyledEngineProvider injectFirst>
              <MobAppointment />{" "}
            </StyledEngineProvider>{" "}
          </Suspense>
        </BrowserRouter>
      ) : app === "MobAppointmentSimulator" ? (
        <BrowserRouter>
          <Suspense fallback={<div>Loading...</div>}>
            <StyledEngineProvider injectFirst>
              <MobAppointmentSimulator />
            </StyledEngineProvider>{" "}
          </Suspense>
        </BrowserRouter>
      ) : app === "MobMedication" ? (
        <BrowserRouter>
          <Suspense fallback={<div>Loading...</div>}>
            <StyledEngineProvider injectFirst>
              {" "}
              <MobMedication />{" "}
            </StyledEngineProvider>
          </Suspense>
        </BrowserRouter>
      ) : app === "MobHistory" ? (
        <BrowserRouter>
          <Suspense fallback={<div>Loading...</div>}>
            {" "}
            <StyledEngineProvider injectFirst>
              <MobHistory />
            </StyledEngineProvider>{" "}
          </Suspense>
        </BrowserRouter>
      ) : app === "MobConsent" ? (
        <BrowserRouter>
          <Suspense fallback={<div>Loading...</div>}>
            <StyledEngineProvider injectFirst>
              <MobConsent />{" "}
            </StyledEngineProvider>{" "}
          </Suspense>
        </BrowserRouter>
      ) : app === "MobCoupon" ? (
        <BrowserRouter>
          <StyledEngineProvider injectFirst>
            <MobCoupon />
          </StyledEngineProvider>
        </BrowserRouter>
      ) : app === "IH" ? (
        <BrowserRouter>
          <StyledEngineProvider injectFirst>
            <MainPatient />
          </StyledEngineProvider>
        </BrowserRouter>
      ) : app === "MobClinic" ? (
        <BrowserRouter>
          <Suspense fallback={<div>Loading...</div>}>
            {" "}
            <StyledEngineProvider injectFirst>
              <MobClinic />{" "}
            </StyledEngineProvider>
          </Suspense>{" "}
        </BrowserRouter>
      ) : app === "MobKYC" ? (
        <BrowserRouter>
          <StyledEngineProvider injectFirst>
            <MobKYC />
          </StyledEngineProvider>
        </BrowserRouter>
      ) : app === "MobPHR" ? (
        <BrowserRouter>
          <StyledEngineProvider injectFirst>
            <MobPHR />
          </StyledEngineProvider>
        </BrowserRouter>
      ) : app === "MobLAB" ? (
        <BrowserRouter>
          <StyledEngineProvider injectFirst>
            <MobLAB />
          </StyledEngineProvider>
        </BrowserRouter>
      ) : app === "Admin" ? (
        <BrowserRouter>
          <StyledEngineProvider injectFirst>
            <Admin />
          </StyledEngineProvider>
        </BrowserRouter>
      ) : app === "WebClinic" ? (
        <BrowserRouter>
          <StyledEngineProvider injectFirst>
            <WebClinic />
          </StyledEngineProvider>
        </BrowserRouter>
      ) : app === "SelectHospital" ? (
        <BrowserRouter>
          <Suspense fallback={<div>Loading...</div>}>
            {" "}
            <StyledEngineProvider injectFirst>
              <MobSelectHospital />
            </StyledEngineProvider>
          </Suspense>
        </BrowserRouter>
      ) : app === "TeleDesktop" ? (
        <BrowserRouter>
          <Suspense fallback={<div>Loading...</div>}>
            <StyledEngineProvider injectFirst>
              <TeleDesktop />
            </StyledEngineProvider>{" "}
          </Suspense>
        </BrowserRouter>
      ) : app === "MobRegister" ? (
        <BrowserRouter>
          <Suspense fallback={<div>Loading...</div>}>
            <StyledEngineProvider injectFirst>
              <MobSmartRegister />
            </StyledEngineProvider>{" "}
          </Suspense>
        </BrowserRouter>
      ) : app === "MobSmartAppointment" ? (
        <BrowserRouter>
          <Suspense fallback={<div>Loading...</div>}>
            {" "}
            <StyledEngineProvider injectFirst>
              <MobSmartAppointment />{" "}
            </StyledEngineProvider>
          </Suspense>
        </BrowserRouter>
      ) : app === "MobPayment" ? (
        <BrowserRouter>
          <Suspense fallback={<div>Loading...</div>}>
            <StyledEngineProvider injectFirst>
              <MobPayment />{" "}
            </StyledEngineProvider>{" "}
          </Suspense>
        </BrowserRouter>
      ) : // app === "MobMakeAppointmentUnsign" ?
      // <BrowserRouter><Suspense fallback={<div>Loading...</div>}> <MobMakeAppointmentUnsign /></Suspense></BrowserRouter>:
      app === "MobInsurance" ? (
        <BrowserRouter>
          <Suspense fallback={<div>Loading...</div>}>
            <StyledEngineProvider injectFirst>
              <MobInsurance />{" "}
            </StyledEngineProvider>{" "}
          </Suspense>
        </BrowserRouter>
      ) : app === "MobRadiology" ? (
        <BrowserRouter>
          <Suspense fallback={<div>Loading...</div>}>
            <StyledEngineProvider injectFirst>
              <MobRadiology />{" "}
            </StyledEngineProvider>{" "}
          </Suspense>
        </BrowserRouter>
      ) : app === "MobSurvey" ? (
        <BrowserRouter>
          <Suspense fallback={<div>Loading...</div>}>
            {" "}
            <StyledEngineProvider injectFirst>
              <MobSurvey />
            </StyledEngineProvider>{" "}
          </Suspense>
        </BrowserRouter>
      ) : isMobile ? (
        <BrowserRouter>
          <StyledEngineProvider injectFirst>
            <MainPatient />
          </StyledEngineProvider>
        </BrowserRouter>
      ) : (
        <BrowserRouter>
          <StyledEngineProvider injectFirst>
            <Manage patientId={patientId} />
          </StyledEngineProvider>
        </BrowserRouter>
      )}
    </React.StrictMode>
  ),

  document.getElementById("root")
);

reportWebVitals();

// For Python loading -- not used for now
// serviceWorker.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// Previous switch in render
// app === "DM" ?
// <BrowserRouter><Manage  patientId={patientId}/></BrowserRouter>:

// app === "OA" ?
// <BrowserRouter><OA /></BrowserRouter>:

// app === "SA" ?
// <SA />:

// app === "PD" ?
// <BrowserRouter><PD /></BrowserRouter>:
